import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { DFPManager, DFPSlotsProvider } from 'react-dfp';
import adSettings from '~content/ads';
import getPageTargetingArguments from '~lib/getPageTargetingArguments';
import Header from './base/Header';

import '~styles/base.scss';

const Layout = ({ children, pathPrefix, path }) => {
  const data = useStaticQuery(graphql`
      query LayoutQuery {
          site {
              siteMetadata {
                  title
              }
          }
      }
  `);
  if (pathPrefix !== '') {
    const pageTargetingArguments = getPageTargetingArguments({
      adSettings,
      keywords: [],
      url: new URL(`${pathPrefix}${path}`, 'https://apps.bostonglobe.com').toString(),
    });
    DFPManager.setTargetingArguments(pageTargetingArguments);
  }

  return (
    <DFPSlotsProvider dfpNetworkId={adSettings.networkId} adUnit={adSettings.unit}>
      <Header />
      <main id="content">
        {children}
      </main>
    </DFPSlotsProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  pathPrefix: PropTypes.string,
  path: PropTypes.string,
};

Layout.defaultProps = {
  pathPrefix: '',
  path: '',
};

export default Layout;
